/*jslint browser */
/*global process */

var $ = jQuery;

/**
 *
 */
export default class CartController
{
    private _accessoryTypeRow: JQuery

    constructor()
    {

    }

    public cartAction(): void
    {
        this.registerEvents();
        //this.blockAccessoryQuantity();
    }

    /**
     *
     * @private
     */
    private registerEvents(): void
    {
        this._accessoryTypeRow = $('.accessory-type-row');
    }

    /*private blockAccessoryQuantity(): void {
        this._accessoryTypeRow.each(function () {
            $(this).parents('.cart_item').find('.qty').attr('disabled','disabled');
        })
    }*/
}